import Vue from 'vue'
import Router from 'vue-router'

import Components from './pages/Components.vue'
import Pagelist from './pages/Pagelist.vue'

import REP300 from './pages/rep300.vue'
import REP050 from './pages/rep050.vue'
import REP080 from './pages/rep080.vue'
import REP082 from './pages/rep082.vue'
import REP085 from './pages/rep085.vue'

Vue.use(Router)

const reloadEnter = (to, from, next) => {
  if (from.name === null || from.name === 'rep085') {
    next({ name: 'rep085' })
  } else {
    next()
  }
}

const enterDevOnly = (to, from, next) => {
  if (process.env.NODE_ENV === 'development') {
    next()
  } else {
    next({ name: 'rep082' })
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/components',
      name: 'components',
      component: Components,
      beforeEnter: enterDevOnly
    },
    {
      path: '/pagelist',
      name: 'pagelist',
      component: Pagelist,
      beforeEnter: enterDevOnly
    },
    {
      path: '/prepare_insurance_application',
      name: 'rep300',
      component: REP300
    },
    {
      path: '/complete_request',
      name: 'rep050',
      component: REP050,
      beforeEnter: reloadEnter,
    },
    {
      path: '/exception',
      name: 'rep080',
      component: REP080,
      beforeEnter: reloadEnter,
    },
    {
      path: '/404',
      name: 'rep082',
      component: REP082
    },
    {
      path: '/500',
      name: 'rep085',
      component: REP085
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
